import React from 'react'
import {connect} from 'react-redux'
import { Container} from 'reactstrap';
import CourseRow from '../components/CourseRow'
import {setCourse} from '../actions/coursesActions'


const mapStateToProps = state => {  
  return {    
    courses: state.courses.courses,    
    filter: state.courses.filter,    
    currCourse: state.courses.currCourse,    
    infoText: state.courses.infoText,    
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return { 
      onCourseChoose: (ownProps, courseIdx) => {        
        dispatch(setCourse(courseIdx))
      },
//    onGetCourses: (ownProps) => {          
//      dispatch(fetchCourses(ownProps.agentLogin))
//    },    
  }
}

class CourseList extends React.Component{
  constructor (props) {
    super(props)
    this.state = {      
      onCourseChoose: props.onCourseChoose,     
    };
    this.handleCourseChoose = this.handleCourseChoose.bind(this);
  }
//  <Row>  
//        <Col md="12"><pre>{JSON.stringify(this.props.courses, null, 2)}</pre></Col>      
//        </Row>
  handleCourseChoose(idx){
    //alert('Wybrano ' + idx)
    this.state.onCourseChoose(this.state, idx)
  }
  render() {
    if (this.props.courses.length>0){      
      return (      
        <Container fluid={true} className="defList">
          <h3>Lista kursów</h3>
          {this.props.courses.map((course, index) => (
            <CourseRow 
              key={index} 
              index={index}
              course={course} 
              qtyNormal={this.props.filter.seatsQtyNormal} 
              qtyReduced={this.props.filter.seatsQtyReduced}
              onCourseChoose={this.handleCourseChoose}
            />
          ))}          
        </Container>
      )
    }
    else
      return (
        <p className="center"><br/>{this.props.infoText}</p>
      )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseList)    


// WEBPACK FOOTER //
// ./src/containers/CourseList.js